/**
 * El bloque de carrito de Woo pinta las fotos a 80×80 (`sizes="80px"`).
 * En CSS las mostramos a 110px; el navegador igual elige 100w/150w del srcset
 * (sobre todo en retina) y se ven blandas. Aquí alineamos width/sizes a 110px
 * para que coja el 300w.
 */

const DISPLAY_PX = 110;

function needsUpgrade(img) {
  return (
    img.getAttribute('width') !== String(DISPLAY_PX) ||
    img.getAttribute('sizes') !== `${DISPLAY_PX}px`
  );
}

function upgradeCartItemImage(img) {
  if (!(img instanceof HTMLImageElement)) {
    return;
  }
  if (!img.closest('.wp-block-woocommerce-cart .wc-block-cart-item__image')) {
    return;
  }
  if (!needsUpgrade(img)) {
    return;
  }

  img.setAttribute('width', String(DISPLAY_PX));
  img.setAttribute('height', String(DISPLAY_PX));
  img.sizes = `${DISPLAY_PX}px`;

  const srcset = img.getAttribute('srcset');
  if (srcset) {
    img.removeAttribute('srcset');
    img.setAttribute('srcset', srcset);
  }
}

export function initCartItemImages() {
  const root = document.querySelector('.wp-block-woocommerce-cart');
  if (!root) {
    return;
  }

  const apply = () => {
    root.querySelectorAll('.wc-block-cart-item__image img').forEach(upgradeCartItemImage);
  };

  apply();

  const observer = new MutationObserver(apply);
  observer.observe(root, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['sizes', 'width', 'srcset'],
  });
}
